<template>
  <div class="input-range">
    <NumberInput
      v-model="modelFrom"
      :placeholder="placeholderFrom"
      :disabled="disabled"
      :max-length="maxLength"
      v-on="listeners"
    />
    <div class="input-range__divider" />
    <NumberInput
      v-model="modelTo"
      :placeholder="placeholderTo"
      :disabled="disabled"
      :max-length="maxLength"
      v-on="listeners"
    />
  </div>
</template>

<script>
import { createPropModel } from 'src/utils/vue.js';

import NumberInput from 'src/components/form/NumberInput/NumberInput.vue';

export default {
  name: 'InputRange',
  components: { NumberInput },
  props: {
    from: Number,
    to: Number,
    placeholderFrom: {
      type: String,
      default: 'От',
    },
    placeholderTo: {
      type: String,
      default: 'До',
    },
    disabled: Boolean,
    maxLength: Number,
  },
  computed: {
    modelFrom: createPropModel('from'),
    modelTo: createPropModel('to'),
    listeners() {
      const { input, ...rest } = this.$listeners;

      return rest;
    },
  },
};
</script>